/*
saikrishna 11/17/2022 2700271704 Added the component for render.
Sai krishna 11/17/2022 2700271704 Action dropdown -- Dynamically rendered fields.
Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
Sohel 11/22/2022 2700271704 formula Rule Group Table set return Type values
Suresh Peddavoora 11/28/2022 2700271704 Alignments for Placeholder in TextField
akhila 12/18/2022 2700271704 changed labels
Raghu 02/28/2023 2700271704 added new classname for inputs
Prakash 13/04/2023 2700271704 remove margin top
Prakash 10/05/2023 2700271704 add theming color
Sohel 11/29/2023 2700271704 Fixed Data Calculation Code Return Type Payload Issue
Sohel 11/30/2023 2700271704 data calculation field disable css modified
*/
import {
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import {Clear, Search} from '@material-ui/icons';
import React, {useContext} from 'react';
import {useDispatch} from 'react-redux';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {handleSearchRuleGroupFieldData} from '../../../../../redux/reducers/EventTactics/EventTactics';

const AddUserDefinedNote = (props) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {values, handleChange, handleBlur, touched, errors, setShowSearch, setFieldValue} = props;
  const dispatch = useDispatch();
  const overRideOptions = [
    {key: 'A', value: 'A - Account'},
    {key: 'S', value: 'S - Seed'},
    {key: 'R', value: 'R - Route'},
  ];
  return (
    <Grid container spacing={4} className="new-standard-textfields m-0">
      <Grid item xs={4} sm={4} className={`form-group ${classes.selectField}`}>
        <FormControl margin="dense" variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            fullWidth
            name="applyTo"
            // className="select-gender"
            className={` select-gender ${classes.labelName}`}
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            placeholder="Select ApplyTo"
            onBlur={handleBlur}
            touched={touched?.applyTo}
            // error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {overRideOptions.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors.applyTo && errors.applyTo}</FormHelperText>
      </Grid>
      <Grid item xs={4} sm={4} className={`form-group wait-date-disable-field`}>
        <TextField
          margin="dense"
          variant="outlined"
          placeholder={`Enter Data Calculations`}
          className={` ${classes.labelName}`}
          label={'Data Calculations'}
          disabled
          // InputLabelProps={{
          //   shrink: true,
          // }}
          name={'ruleGroup'}
          value={values?.ruleGroup?.dataCalculation ? values?.ruleGroup?.dataCalculation : values?.ruleGroup ? values?.ruleGroup : ''}
          onChange={(e) => {
            setFieldValue('ruleGroup', e.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search
                  className={` ${classes.iconSearch}`}
                  onClick={() => {
                    dispatch(
                      handleSearchRuleGroupFieldData({
                        status: true,
                        fieldName: 'ruleGroup',
                        setFieldValue: setFieldValue,
                        setShowSearch: setShowSearch,
                        returnType: 'Text',
                      }),
                    );
                    setShowSearch(true);
                  }}
                  size="sm"
                />
                <Clear
                  className={` ${classes.iconSearch}`}
                  onClick={(e) => setFieldValue('ruleGroup', '')}
                />
              </InputAdornment>
            ),
          }}
          fullWidth
          onBlur={handleBlur}
          touched={touched.ruleGroup}
          error={touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
          helperText={touched?.ruleGroup && errors.ruleGroup && errors.ruleGroup}
        />
      </Grid>
      <Grid item xs={12} sm={4} className={`form-group AccountMessages-TextField`}>
        <TextField
          margin="dense"
          variant="outlined"
          className={`text-description-fields ${classes.labelName} `}
          placeholder="Enter Note To Add"
          label="Enter Note To Add"
          multiline
          rows={3}
          // InputLabelProps={{
          //   shrink: true,
          // }}
          name="noteToAdd"
          value={values?.noteToAdd}
          onChange={handleChange}
          fullWidth
          onBlur={handleBlur}
          touched={touched.noteToAdd}
          error={touched?.noteToAdd && errors.noteToAdd && errors.noteToAdd}
        />
      </Grid>
    </Grid>
  );
};

export default AddUserDefinedNote;
